import React, { useContext } from 'react'

import { DataContext } from './DataContext'
import NoDataComponent from '../../../elem/table/client/NoDataComponent'
import TableContent from '../../../elem/table/client/TableContent'
import parseColumns from '../../../../utils/table/parseColumns'
import withConfig from '../../../wrappers/withConfig'

export default withConfig(({ config }) => {
    const { detailData, filterData, visibleDetailTab, isLoading } = useContext(DataContext)
    const { ID_COLUMN, EXPLORER_LINK_COLUMN } = config
    if (
            detailData &&
            detailData.waterLevel &&
            filterData &&
            filterData.waterLevel &&
            visibleDetailTab === 'waterLevel'
    ) {
        const formFields = filterData.waterLevel
        const sampleDetailsData = detailData.waterLevel
        const columns = parseColumns(sampleDetailsData, formFields, EXPLORER_LINK_COLUMN, ID_COLUMN)
        return (
            <div className="is-size-7 sampleDetailWrapper">
                <NoDataComponent data={sampleDetailsData} isLoading={isLoading}/>
                <TableContent
                    name="waterLevelDetails"
                    columns={columns}
                    data={sampleDetailsData}
                    containerClass={'detailTableWrapper'}
                    loading={isLoading}
                    initialSort={'MeasurementDate'}
                    initialSortDesc={true}
                />
            </div>
        )

    } else {
        return null
    }
})